<template>

  <div v-if="editMode || filled">
    <div class="card-header">
      <i
        class="fas fa-pencil-alt"
        :title="$t('Edit')"
        v-if="!editable && editMode"
        @click.stop="editSection(true)"
        style="cursor: pointer; float: right;">
        </i>
      <strong>{{ $t('Details') }}</strong>
    </div>
    <div
      v-if="editable"
      class="card-body">

      <form v-on:submit.prevent="save(candidateEdit)">

        <div class="form-group">
          <label>{{ $t('Gender') }}</label>
          <div class="form-group">
            <div class="form-check form-check-inline">
              <input class="form-check-input" type="radio" id="male" value="male" v-model="candidateEdit.gender">
              <label class="form-check-label" for="male">{{ $t('Male') }}</label>
            </div>
            <div class="form-check form-check-inline">
              <input class="form-check-input" type="radio" id="female" value="female" v-model="candidateEdit.gender">
              <label class="form-check-label" for="female">{{ $t('Female') }}</label>
            </div>
            <div class="form-check form-check-inline">
              <input class="form-check-input" type="radio" id="other" value="other" v-model="candidateEdit.gender">
              <label class="form-check-label" for="other">{{ $t('Other') }}</label>
            </div>
            <div class="form-check form-check-inline">
              <input class="form-check-input" type="radio" id="prefer_not_to_say" value="prefer_not_to_say" v-model="candidateEdit.gender">
              <label class="form-check-label" for="prefer_not_to_say">{{ $t('Prefer not to say') }}</label>
            </div>

          </div>
          <ValidateMessage :error="validateErrors.gender" />
        </div>

        <div class="form-group">
          <label>{{ $t('Date of birth') }}</label>
          <date
            v-model="candidateEdit.birth_date"
            placeholder=""
            width="200"
            initialSelect="year">
            </date>
          <ValidateMessage :error="validateErrors.birth_date" />
        </div>

        <div class="form-group">
          <label class="control-label">{{ $t('Experience level') }}</label>
          <select-experience-level
            v-model="candidateEdit.experience_level">
            </select-experience-level>
          <ValidateMessage :error="validateErrors.experience_level" />
        </div>

        <div class="form-group">
          <label class="control-label">{{ $t('Professional category') }}</label>
          <select-position-category
            v-model="candidateEdit.position_category">
            </select-position-category>
          <ValidateMessage :error="validateErrors.position_category" />
        </div>

        <hr>

        <div class="mb-3"><strong>{{ $t('Address') }}</strong></div>

        <div class="row">
          <div class="col-sm">
            <div class="form-group">
              <select-country
                v-model="candidateEdit.country"
                :placeholder="$t('Country')">
                </select-country>
              <ValidateMessage :error="validateErrors.country" />
            </div>
          </div>
          <div class="col-sm">
            <div class="form-group">
              <input
                class="form-control"
                type="text"
                v-model="candidateEdit.region"
                :placeholder="$t('State')">
              <ValidateMessage :error="validateErrors.region" />
            </div>
          </div>
        </div>

        <div class="row">
          <div class="col-sm">
            <div class="form-group">
              <input
                class="form-control"
                type="text"
                v-model="candidateEdit.city"
                :placeholder="$t('City')">
              <ValidateMessage :error="validateErrors.city" />
            </div>
          </div>
          <div class="col-sm">
            <div class="form-group">
              <input
                class="form-control"
                type="text"
                v-model="candidateEdit.neighborhood"
                :placeholder="$t('Neighborhood')">
              <ValidateMessage :error="validateErrors.neighborhood" />
            </div>
          </div>
        </div>

        <div class="row">
          <div class="col-sm">
            <div class="form-group">
              <input
                class="form-control"
                type="text"
                v-model="candidateEdit.address" 
                :placeholder="$t('Address, Number, Complement')">
              <ValidateMessage :error="validateErrors.address" />
            </div>
          </div>
          <div class="col-sm">
            <div class="form-group">
              <input
                class="form-control"
                type="text"
                v-model="candidateEdit.zipcode"
                :placeholder="$t('Zip code')">
              <ValidateMessage :error="validateErrors.zipcode" />
            </div>
          </div>
        </div>

        <div :class="{'box-loading': loading}">
          <button
            type="submit"
            class="btn btn-primary">
            {{ $t('Save') }}
            </button>
          <button
            type="button"
            class="btn btn-light"
            @click.stop="editSection(false)">
            {{ $t('Cancel') }}
            </button>
        </div>

      </form>

    </div>
    <div
      v-if="!editable"
      class="card-body">

      <div class="row mb-2" v-if="editMode || candidate.gender">
        <div class="col-sm-3">
          <strong>{{ $t('Gender') }}</strong>
        </div>
        <div class="col-sm-8">
          {{ gender ? gender : '--' }}
        </div>
      </div>

      <div class="row mb-2" v-if="editMode || candidate.birth_date">
        <div class="col-sm-3">
          <strong>{{ $t('Birth date') }}</strong>
        </div>
        <div class="col-sm-8">
          {{ age || '--' }}
        </div>
      </div>

      <div class="row mb-2" v-if="editMode || candidate.experience_level">
        <div class="col-sm-3">
          <strong>{{ $t('Experience level') }}</strong>
        </div>
        <div class="col-sm-8">
          {{ experienceLevel ? experienceLevel.name : '--' }}
        </div>
      </div>

      <div class="row mb-2" v-if="editMode || candidate.position_category">
        <div class="col-sm-3">
          <strong>{{ $t('Professional category') }}</strong>
        </div>
        <div class="col-sm-8">
          {{ positionCategory ? positionCategory.name : '--' }}
        </div>
      </div>

      <div class="row mb-2" v-if="editMode || fullAddress">
        <div class="col-sm-3">
          <strong>{{ $t('Address') }}</strong>
        </div>
        <div class="col-sm-8">
          {{ fullAddress || '--' }}
        </div>
      </div>


    </div>
  </div>

</template>

<script>
import _ from 'lodash'
import Date from '@/components/Fields/Date'
import SelectSource from '@/components/Fields/SelectSource'
import SelectCountry from '@/components/Fields/SelectCountry'
import InputMoney from '@/components/Fields/InputMoney'
import SelectExperienceLevel from '@/components/Fields/SelectExperienceLevel'
import SelectPositionCategory from '@/components/Fields/SelectPositionCategory'
import moment from 'moment'

export default {
  name: 'CandidateProfileDetails',
  components: {
    Date,
    SelectSource,
    SelectCountry,
    InputMoney,
    SelectExperienceLevel,
    SelectPositionCategory
  },
  props: [
    'editMode'
  ],
  data () {
    return {
      loading: false,
      sectionEdit: false,
      candidateEdit: {},
      validateErrors: false
    }
  },
  created () {
  },
  computed: {
    editable () {
      return this.sectionEdit && this.editMode
    },
    resources () {
      return this.$store.getters.getResources
    },
    candidate () {
      return this.$store.getters.getCandidate
    },
    gender () {
      if (this.candidate.gender) {
        return {
          'male': this.$t('Male'),
          'female': this.$t('Female'),
          'other': this.$t('Other'),
          'prefer_not_to_say': this.$t('Prefer not to say')
        }[this.candidate.gender]
      } else {
        return null
      }
    },
    fullAddress () {
      const candidate = this.$store.getters.getCandidate
      return [
        candidate.address,
        candidate.neighborhood,
        candidate.city,
        candidate.region,
        candidate.zipcode,
        candidate.country
      ]
      .filter((v) => { return v && v.trim() })
      .join(', ')
    },
    age () {
      if (this.candidate.birth_date) {
        const objDate = moment(this.candidate.birth_date)
        const short = this.$d(objDate, 'short')
        const age = this.$t('n_years', { age: moment().diff(objDate, 'years') })
        return `${short} (${age})`
      } else {
        return null
      }
    },
    positionCategory () {
      return this.resources.position_category.find((val) => {
        return val.key === this.candidate.position_category
      })
    },
    experienceLevel () {
      return this.resources.experience_level.find((val) => {
        return val.key === this.candidate.experience_level
      })
    },
    educationDegree () {
      return this.resources.education_degree.find((val) => {
        return val.key === this.candidate.education_degree
      })
    },
    filled () {
      return this.candidate.gender || this.candidate.birth_date || this.fullAddress || this.positionCategory || this.experienceLevel || this.educationDegree
    }
  },
  methods: {
    editSection (status) {
      this.sectionEdit = status
      this.candidateEdit = _.pick(this.candidate, [
        '_id',
        'gender',
        'address',
        'birth_date',
        'neighborhood',
        'city',
        'region',
        'country',
        'experience_level',
        'position_category',
        'zipcode'
      ])
    },
    save (data) {
      this.loading = true

      this.$store.dispatch('updateCandidate', data)
      .then((response) => {
        this.loading = false
        this.sectionEdit = false
      })
      .catch((err) => {
        this.loading = false
        if (err.response.data.name === 'ValidationError') {
          this.validateErrors = err.response.data.errors
        }
      })
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/Candidate/Profile/CandidateProfileDetails.vue